import { Loader2 } from "lucide-react"

export function RouteLoadingFallback() {
  return (
    <div
      className="flex min-h-[50vh] w-full items-center justify-center"
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-test="route-loading"
    >
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      <span className="sr-only">Chargement…</span>
    </div>
  )
}
